import { useFormStore } from '@/stores/form'
import { DateTime } from 'luxon'
import { db } from '../../fileStore/db.js'

const changeAskFillFileModalVisibility = async (isShow) => {
  localStorage.setItem('isNotShowAskFillFileModal', isShow)
}

const changeIsNeedToSaveFile = async (isSave) => {
  localStorage.setItem('isNeedSaveFile', isSave)
}

const addBulkFiles = async (files) => {
  return await db.files.bulkPut(files)
}

const queryFileByName = async (key, value) => {
  return await db.files.where(key).equalsIgnoreCase(value).toArray()
}

const saveFileToLocal = async (documentList) => {
  const docList = documentList
    .filter((item) => {
      return Object.prototype.toString.call(item.attachmentFile) === '[object File]'
    })
    .map((document) => {
      const nameObj = generateUniqueFileName(document.attachmentType)

      return {
        name: document.name,
        name1: nameObj.name1,
        name2: nameObj.name2,
        name3: nameObj.name3,
        content: document.attachmentFile,
        extract: JSON.stringify(document.attachmentType)
      }
    })
  return await addBulkFiles(docList)
}

// generate three file unique names that will be match by queryFileByName
const generateUniqueFileName = (fileInfo) => {
  const formStore = useFormStore()
  const fileTypeId = fileInfo.id
  const unifiedNumber = formStore.draft.request?.unifiedNumber
  const genderId = formStore.draft.request?.genderId
  const passportCountryId = formStore.draft.request?.passportCountryId
  const passportNumber = formStore.draft.request?.passportNumber
  const dateOfBirth = formStore.draft.request?.dateOfBirth
  const formatDate = DateTime.fromJSDate(new Date(dateOfBirth)).toFormat('dd-MM-yyyy')
  const englishName = formStore.draft.request?.englishName
  const res = {
    name1: unifiedNumber ? `${unifiedNumber}_${fileTypeId}` : '',
    name2:
      passportCountryId && passportNumber
        ? `${passportCountryId}_${passportNumber}_${fileTypeId}`
        : '',
    name3: genderId && englishName && dateOfBirth ? `${englishName}_${genderId}_${formatDate}` : ''
  }
  return res
}

export default function () {
  return {
    changeAskFillFileModalVisibility,
    changeIsNeedToSaveFile,
    queryFileByName,
    saveFileToLocal,
    generateUniqueFileName
  }
}
